import { Button, ExpandCollapse, Icon } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../../contentConstants';
import { useModalState } from '../../../../utilities/hooks';
import { GroupQuestionBranchingLogicModal } from '../../../branching/GroupQuestionBranchingLogicModal';
import { Col3Col9 } from '../../../common';

export type BranchingAndLayoutTableUtilitiesProps = {
	expanded: boolean;
	onExpandCollapse: (expanded: boolean) => void;
	resultsCount: number;
};

const TableUtilitiesContainer = styled.div.attrs<{}>({
	className: 'tws-table-utlities-container',
	'data-testid': 'tws-table-utlities-container',
})`
	display: flex;
	margin: 2rem 0 0 0;

	&:first-of-type {
		margin-top: 0;
	}

	&:last-of-type {
		margin-bottom: 0;
	}
`;
TableUtilitiesContainer.displayName = 'TableUtilitiesContainer';

const RecordTotal = styled.div`
	display: flex;
	flex: 1 1 0;
	align-items: center;

	i {
		font-size: 16px;
		vertical-align: middle;
		margin-right: ${globalVars.spacing5};
		margin-left: ${globalVars.spacing10};
		width: 16px;
	}

	span {
		font-size: 11px;
		color: ${globalVars.mainGray};
		font-weight: ${globalVars.fontWeightThick};
		line-height: 11px;
	}

	@media (min-width: 0) and (max-width: 768px) {
		i {
			font-size: 19px;
			width: 19px;
		}

		span {
			font-size: 12px;
		}
	}
`;
RecordTotal.displayName = 'RecordTotal';

const ExpandCollapseContainer = styled(ExpandCollapse).attrs<{}>({
	'data-testid': 'tws-table-utlities-expand-collapse',
})`
	display: flex;
	flex: 1 1 0;
	justify-content: flex-end;
	align-items: center;

	div {
		height: 30px;
		width: 30px;
		padding-top: 5px !important;
	}
`;
ExpandCollapseContainer.displayName = 'ExpandCollapseContainer';

const GroupQuestionLogicButton = styled(Button)`
	margin-left: auto !important;
`;
GroupQuestionLogicButton.displayName = 'GroupQuestionLogicButton';

export const BranchingAndLayoutTableUtilities = ({
	expanded,
	onExpandCollapse: handleExpandCollapse,
	resultsCount,
}: BranchingAndLayoutTableUtilitiesProps) => {
	const { isOpen: isGroupQuestionLogicModalOpen, toggleModal: toggleGroupQuestionLogicModal } = useModalState();

	return (
		<>
			<TableUtilitiesContainer>
				<GroupQuestionLogicButton color='primary' size='md' onClick={toggleGroupQuestionLogicModal}>
					{ContentConstants.LOGIC_AND_LAYOUT.GROUP_QUESTION_LOGIC.TITLE}
				</GroupQuestionLogicButton>
				<GroupQuestionBranchingLogicModal isOpen={isGroupQuestionLogicModalOpen} onClosed={toggleGroupQuestionLogicModal} />
			</TableUtilitiesContainer>
			<Col3Col9
				label={ContentConstants.SUBSECTIONHEADERS_INSTRUCTIONS}
				clearHeight='0px'
				clearBefore='20px'
				className='tws-survey-audience-name'
			>
				<div>Follow the guidelines for designing your survey</div>
				<div>
					<b>First</b> order questions by clicking the questions number and typing in the decimal value.
				</div>
				<div>
					<b>Second</b> add page elements such as page breaks, section breaks, and section headers.
				</div>
				<div>
					<b>Third</b> add question logic.
				</div>
			</Col3Col9>
			<TableUtilitiesContainer>
				<RecordTotal className='tws-paging-total-record-count'>
					<Icon name='total' />
					<span className='totalRecordsCount'>{resultsCount}</span>
				</RecordTotal>
				<ExpandCollapseContainer isExpanded={expanded} onExpandCollapse={handleExpandCollapse} />
			</TableUtilitiesContainer>
		</>
	);
};
